import { IntlShape } from 'react-intl';
import { CHECK, VIRTUAL_CARD } from 'common/constants';
import { PaymentMethod } from 'pages/HighVolumeLandingPage/constants';
import { PAYMENT_METHOD_CHECK, PAYMENT_METHOD_CREDIT_CARD } from './constants';
import { messages } from './messages';
import { PaymentOptionsType } from './types';

export const options = (
  intl: IntlShape,
  landingPageFlag: boolean | undefined
): PaymentOptionsType[] => [
  {
    label: `${intl.formatMessage(messages.check)}`,
    value: landingPageFlag === true ? PaymentMethod.AP_CHECK : CHECK,
    dataTestId: `${PAYMENT_METHOD_CHECK}`
  },
  {
    label: `${intl.formatMessage(messages.creditCard)}`,
    value: landingPageFlag === true ? PaymentMethod.VIRTUAL_CARD : VIRTUAL_CARD,
    dataTestId: `${PAYMENT_METHOD_CREDIT_CARD}`
  }
];
